import type { QueryClient } from '@tanstack/react-query';
import { clearMatchResultLocally } from './matchHandoff';

const UPSELL_BENEFIT_INTENT_KEY = 'plumaa_upsell_benefit_intent';
const PENDING_CHECKOUT_CLUB_STORAGE_KEY = 'plumaa_pending_checkout_club_id';

/** Dados de sessão/clube no React Query e storage local não podem vazar entre contas. */
export async function clearUserScopedQueryCache(
	queryClient: QueryClient,
): Promise<void> {
	try {
		sessionStorage.removeItem(UPSELL_BENEFIT_INTENT_KEY);
		sessionStorage.removeItem(PENDING_CHECKOUT_CLUB_STORAGE_KEY);
	} catch {
		/* ignore */
	}
	// Resíduo de versões que guardavam os indicados do match no browser.
	clearMatchResultLocally();

	const userScopedKeys = [
		['clubs'],
		['sessions'],
		['session'],
		['user'],
		// Match é por conta: sem isto os indicados sobrevivem ao logout.
		['match'],
	] as const;

	await Promise.all(
		userScopedKeys.map((queryKey) =>
			queryClient.cancelQueries({ queryKey, exact: false }),
		),
	);

	for (const queryKey of userScopedKeys) {
		queryClient.removeQueries({ queryKey, exact: false });
	}
}
